/**=========================================================
 * Module: references.js
 * References Controller
 =========================================================*/


App.controller('ReferencesController',
    ['$rootScope', '$scope', '$state', '$translate', '$window', '$localStorage', '$timeout', 'toggleStateService', 'Restangular', 'DataService', 'ngDialog', '$filter',
        function ($rootScope, $scope, $state, $translate, $window, $localStorage, $timeout, toggle, R, D, ngDialog, $filter) {
            "use strict";

            $scope.type = 'reference';
            $scope.id = $state.params.filter;

            $scope.model = {};
            $scope.error = {};
            $scope.page = {
                title: 'labels.REFERENCES',
                subTitle: ''
            };


            $scope.initialized = false;
            $scope.watchActivated = false;
            $scope.init = function () {

                if ($rootScope.user.id && ($scope.id != 'undefined')) {
                    $scope.initialized = true;

                    if($rootScope.user.groupType=='ADMIN'){
                        D.load('group', $scope.id, { cache: false }).then(function (result) {
                            $scope.client = result;
                            $scope.page.subTitle = result.name;
                            D.query('group', 'type=SUPPLIER&_withAccounts=true', { cache: false }).then(function (result) {
                                $scope.suppliers = result;
                                D.query('reference', 'client=' + $scope.id, { cache: false }).then(function (result) {
                                    $scope.references = result;

                                    $scope.availableSuppliers = [];
                                    for (var i = 0; i < $scope.suppliers.length; i++) {
                                        var sid = $scope.suppliers[i].id;
                                        var isRef = $scope.references.filter(function (r) {
                                            return r.supplier == sid;
                                        }).length > 0;
                                        if (!isRef) {
                                            $scope.availableSuppliers.push($scope.suppliers[i]);
                                        }
                                    }
                                    $scope.refForm = {}
                                    for (var i=0; i<$scope.references.length; i++){
                                        var ref = $scope.references[i];
                                        $scope.refForm[ref.id] = $scope.addForm(ref)
                                    }
                                });
                            }).catch(console.error)
                            D.query('account', 'group=' + $scope.id, { cache: false }).then(function(result){
                                $scope.accounts = result;
                                $scope.askTMform = {
                                    title: '',
                                    status: '',
                                    type: 'group',
                                    model: $scope.client,
                                    fields: [{
                                        available: true,
                                        type: 'select',
                                        name: 'account',
                                        data: $scope.accounts,
                                        placeholder: '',
                                        valueField: 'id',
                                        labelField: 'name',
                                        required: true,
                                    },{
                                        available: true,
                                        type: 'textarea',
                                        name: 'custommessage'
                                    }]
                                }
                            }).catch(console.error)
                            D.query('group', 'supergroup=' + $scope.client.supergroup, { cache: false }).then(function(result){
                                $scope.copyFromForm = {
                                    title: '',
                                    status: '',
                                    type: 'reference',
                                    model: { action: 'CopyReferencesFrom', client: $scope.client.id },
                                    fields: [{
                                        available: true,
                                        type: 'select',
                                        name: 'copyFrom',
                                        data: result.filter(function(r){ return r.id!=$scope.client.id}).sort(function(a, b){ return a.name > b.name ? 1 : -1}),
                                        placeholder: '-',
                                        valueField: 'id',
                                        labelField: 'name',
                                        noLabel: true,
                                        required: true,
                                    },{
                                        available: true,
                                        type: 'submit'
                                    }],
                                    submit: function(){
                                        D.save('reference', this.model).then(function(resp){
                                            $state.go($state.current, {}, {reload: true});
                                        }).catch(console.error);
                                    }
                                }
                            }).catch(console.error)
                        });
                        
                        
                    } else if($rootScope.user.groupType=='CLIENT'){
                        D.load('template', 'ASKTM_TO_SUPPLIER-'+$rootScope.user.language).then(function(result){
                            $scope.askTMform = {
                                title: '',
                                status: '',
                                type: 'group',
                                model: {
                                    emailtext: result.text.replace(/{{account.group.name}}/g, $rootScope.user.group.name).replace(/{{account.group.id}}/g, $rootScope.user.group.id).replace(/{{app.url}}/g, 'https://app.aqrate.biz').replace(/{{customMessage}}/g,''),
                                    custommessage: ''
                                },
                                fields: [{
                                    available: true,
                                    type: 'static',
                                    name: 'emailtext'
                                },{
                                    available: true,
                                    type: 'textarea',
                                    name: 'custommessage'
                                }]
                            }
                        }).catch(console.error)
                        D.query('reference', '', { cache: false }).then(function (result) {
                            $scope.references = result;
                            $scope.refForm = {}
                            for (var i=0; i<$scope.references.length; i++){
                                var ref = $scope.references[i];
                                $scope.refForm[ref.id] = $scope.addForm(ref)
                            }
                        }).catch(console.error);
                    }




                } else {
                    if (!$scope.watchActivated) {
                        $scope.watchActivated = true;
                        $rootScope.$watch('user.id', function () {
                            if (!$scope.initialized) {
                                $scope.init();
                            }
                        });
                    }
                }
            }

            function updateReference(ref, field){
                for(var i=0; i<$scope.references.length; i++){
                    if(ref.id==$scope.references[i].id){
                        $scope.references[i][field] = ref[field];
                    }
                }
            }

            $scope.addForm = function(ref){
                return {
                    title: '',
                    status: '',
                    type: 'reference',
                    model: ref,
                    fields: [{
                        available: true,
                        type: $rootScope.user.groupType=='ADMIN' ? 'select' : 'static',
                        name: $rootScope.user.groupType=='ADMIN' ? 'referent' : 'referentName',
                        data: $rootScope.user.groupType=='ADMIN' ? $scope.suppliers.filter(function(s){ return s.id==ref.supplier;})[0].accounts : [],
                        valueField: 'id',
                        labelField: 'name',
                        required: true,
                        onchange: function(){ 
                            updateReference(ref, 'referent') 
                        }
                    },{
                        available: $rootScope.user.groupType=='ADMIN' || $scope.references.filter(function(r) { return r.code; }).length>0,
                        type: $rootScope.user.groupType=='ADMIN' ? 'text' : 'static',
                        name: 'code',
                        onchange: function(){ 
                            updateReference(ref, 'code') 
                         }
                    },{
                        available: true,
                        type: 'static',
                        name: 'referentEmail',
                        label: 'fields.EMAIL'
                    },{
                        available: $rootScope.user.groupType=='CLIENT',
                        type: 'text',
                        name: 'phone',
                        label: 'fields.PHONE2',
                        onchange: function(){ 
                            updateReference(ref, 'phone') 
                        }
                    },{
                        available: $rootScope.user.groupType=='CLIENT',
                        type: 'textarea',
                        name: 'notes'
                    },{
                        available: $rootScope.user.groupType=='CLIENT',
                        type: 'submit',
                        name: 'empty',
                        label: 'labels.SAVE'
                    }],
                    submit: function(){
                        var self = this;
                        self.status = 'submitting'
                        self.model.action = 'SetReferenceNotes';
                        D.save('reference', self.model).then(function(res){
                            self.status = 'submitted';
                        }).catch(console.error)
                    }
                }
            }

            $scope.addRef = function(supplierId, supplierName) {
                var newRef = {
                    client: $scope.id,
                    code: '',
                    _id: $scope.id + '-' + supplierId,
                    referent: null,
                    referentName: '',
                    supplier: supplierId,
                    supplierName: supplierName,
                    new: true
                }
                $scope.references.unshift(newRef);
                for(var i=0; i<$scope.availableSuppliers.length; i++){
                    if($scope.availableSuppliers[i].id===supplierId){
                        $scope.availableSuppliers.splice(i, 1);
                        break;
                    }
                }
                
                $scope.refForm[$scope.id + '-' + supplierId] = $scope.addForm(newRef);
                $scope.savingAll = false;
            }

            $scope.removeRef = function(ref){
                $scope.confirmLabel = 'CONFIRMREMOVEREF';
                $scope.model = $scope.model || {};
                $scope.model.removingSupplier = ref.supplierName;
                ngDialog.openConfirm({
                    template: '/app/views/entities/confirm-withlabel.html',
                    className: 'ngdialog-theme-default',
                    scope: $scope
                }).then(function(value){
                    D.remove('reference', ref.id).then(function(){
                        $scope.availableSuppliers.push($scope.suppliers.filter(function(s) { return s.id == ref.supplier; })[0]);
                        $scope.references = $scope.references.filter(function(r) { return r.id!=ref.id; });
                    }).catch(console.error)
                })
                $scope.savingAll = false;
            }
            
            $scope.saveAll = function(){
                $scope.savingAll = true;
                $scope.saving = {};
                for(var i=0; i<$scope.references.length; i++){
                    var ref = $scope.references[i];
                    $scope.references[i].new = false;
                    var f = function(ref){
                        ref._id = ref.id || ref._id;
                        $scope.saving[ref._id] = { status: 'saving' };
                        D.save('reference', ref)
                            .then(function(response){
                                $scope.saving[ref._id] = { status: 'saved' };
                                ref.id = ref._id;
                                D.load('reference', ref.id).then(function(resp){
                                    for(var i=0; i<$scope.references.length; i++){
                                        if($scope.references[i].id==resp.id){
                                            resp._id = resp.id;
                                            $scope.references[i] = resp;
                                            //$scope.refForm[resp.id].model = resp;
                                        }
                                    }
                                }).catch(console.error)
                            })
                            .catch(function(err){
                                $scope.saving[ref._id] = { status: 'error' };
                                
                            })
                    }(ref);
                }
            }

            $scope.askTM = function (supplierId, supplierName) {
                $scope.confirmLabel = $rootScope.user.groupType=='ADMIN' ? 'ASKTMCONFIRMADMIN' : 'ASKTMCONFIRM';
                $scope.model = {
                    supplierName: supplierName,
                    account: ''
                };
                ngDialog.openConfirm({
                    template: '/app/views/entities/confirm-asktm.html',
                    className: 'ngdialog-theme-default ngdialog-theme-large',
                    scope: $scope
                }).then(function (value) {
                    var ref = $scope.references.filter(function(r) { return r.supplier==supplierId;})[0];
                    ref.action = 'AskTM';
                    ref.sender = $rootScope.user.groupType=='ADMIN' ? $scope.askTMform.model.account : $rootScope.user.id;
                    ref.customMessage = $scope.askTMform.model.custommessage || ''
                    if(ref.sender){
                        D.save('reference', ref).then(function(response){
                            $scope.messageLabel = 'ASKTMSENT';
                            $scope.askTMrecipient = supplierName;
                            ngDialog.open({
                                template: '/app/views/entities/popup-ok.html',
                                className: 'ngdialog-theme-default',
                                scope: $scope
                            })
                        }).catch(console.error)
                    }
                })
            }

            $scope.showFiles = function(ref){
                $scope.refFiles = [];
                D.query('file', 'type=reference&field=tmupload&entityId=' + ref.id, { cache: false }).then(function(response){
                    $scope.refFiles = response;
                    
                  }).catch(console.error);
                ngDialog.open({
                    template: '/app/views/entities/reference-files.html',
                    className: 'ngdialog-theme-default ngdialog-theme-large',
                    scope: $scope
                })
            }

            $scope.showUpload = function(ref){
                $scope.refFiles = [];
                D.query('file', 'type=reference&field=tmupload&entityId=' + ref.id, { cache: false }).then(function(response){
                    $scope.refFiles = response;
                    
                  }).catch(console.error);
                  $scope.supplier = ref.supplier;
                ngDialog.open({
                    template: '/app/views/entities/tm-upload.html',
                    className: 'ngdialog-theme-default ngdialog-theme-large',
                    controller: 'TmuploadController',
                    scope: $scope
                })
            }

            $scope.openForm = function(file){
                file.notes = file.info.tmNotes;
                $scope.fileForm = {
                    title: 'labels.REPORTANDNOTES',
                    status: '',
                    type: 'file',
                    model: file,
                    fields: [{
                        available: true,
                        type: 'static',
                        name: 'name'
                    },{
                        available: true,
                        type: $rootScope.user.groupType=='ADMIN' ? 'textarea' : 'staticFormatted',
                        name: 'notes'
                    },{
                        available: true,
                        type: 'file',
                        limit: -1,
                        canUpload: $rootScope.user.groupType=='ADMIN',
                        canDelete: $rootScope.user.groupType=='ADMIN',
                        name: 'report',
                        zipFilename: file.name + '.' + $filter('translate')('fields.REPORT').replace(' ','_'),
                        bucket: $rootScope.bucketName($scope.client.id) 
                    },{
                        available: $rootScope.user.groupType=='ADMIN',
                        type: 'submit'
                    }],
                    submit: function(){
                        $scope.fileForm.status = 'submitting'
                        $scope.fileForm.model.action = 'SetFileInfo';
                        let info = $scope.fileForm.model.info;
                        $scope.fileForm.model.info = { 
                            tmNotes: $scope.fileForm.model.notes || ''
                        }
                        info.tmNotes = $scope.fileForm.model.info.tmNotes;
                        D.save('file', $scope.fileForm.model).then(function(res){
                            $scope.fileForm.status = 'submitted';
                        }).catch(console.error)
                        $scope.fileForm.model.info = info;
                    }
                }
                ngDialog.open({
                    template: '/app/views/entities/reference-fileform.html',
                    className: 'ngdialog-theme-default ngdialog-theme-large',
                    scope: $scope
                })
            }

            $scope.init();
        }
    ]);